import type {
    FavoritePersonaData,
    FavoritePersonaNode,
    OutlookFavoriteServiceDataType,
} from 'owa-favorites-types';
import { getSelectedAccountMailboxInfo } from 'owa-account-source-list-store';

export function convertFavoritePersonaDataToFavoritePersonaNode(
    data: FavoritePersonaData
): FavoritePersonaNode {
    return {
        id: data.favoriteId,
        treeType: 'favorites',
        type: 1,
        allEmailAddresses: data.allEmailAddresses,
        displayName: data.displayName,
        mainEmailAddress: data.mainEmailAddress,
        searchFolderId: data.searchFolderId,
        isSyncUpdateDone: true,
        isJustAdded: false,
        isSearchFolderPopulated: data.isSearchFolderPopulated,
        markedForDeletion: false,
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2322 (26,9): Type 'null' is not assignable to type 'DropViewState | undefined'.
        // @ts-expect-error
        dropViewState: null,
        personaId: data.personaId,
    };
}

export function createInitialFavoritePersonaData(
    favoriteId: string,
    displayName: string,
    emailAddress: string
): FavoritePersonaData {
    return {
        treeType: 'favorites',
        type: 'persona',
        favoriteId: favoriteId,
        displayName: displayName,
        searchFolderId: undefined,
        client: 'OWA',
        allEmailAddresses: [emailAddress],
        personaId: undefined,
        mainEmailAddress: emailAddress,
        isSearchFolderPopulated: false,
        isSyncUpdateDone: true,
        mailboxInfo: getSelectedAccountMailboxInfo(),
    };
}

export function createAddFavoritePersonaServicePayload(
    displayName: string,
    emailAddress: string
): OutlookFavoriteServiceDataType {
    return {
        Type: 'persona',
        DisplayName: displayName,
        SingleValueSettings: [
            {
                Key: 'MainEmailAddress',
                Value: emailAddress,
            },
        ],
        Client: 'OWA',
    };
}
